import { put } from 'redux-saga/effects';
import ACTIONS from './actions';


export default function* sagas(lang) {
    yield put({ type: ACTIONS.TRANSLATE , payload :  lang})
}
